import { put, select, takeEvery } from 'redux-saga/effects'
import * as Sentry from "@sentry/browser";
import i18next from "i18next";

// @ts-expect-error
import { confirmRewriteImageTrigger, setIsImageNameExist, setIsButtonDisable } from 'store/entities/gallery/actions.js'
// @ts-expect-error
import { getGalleryActivitiesImages } from 'store/entities/gallery/selectors.js'
// @ts-expect-error
import { showError, showWarning } from 'store/entities/toastr/utils/index.js'
import { ICheckImageName } from 'store/entities/gallery/sagas/interfaces'
import { ACTIVITY_DEFAULT_IMAGE_MESSAGE } from 'app/constants/activity'

export default function* checkImageNameSaga() {
  yield takeEvery(confirmRewriteImageTrigger, handleCheckImageName)
}

export function* handleCheckImageName({ payload }: ICheckImageName) {
  try {
    const { imageDomainWithId, fileName } = payload
    const imageDomain = imageDomainWithId.split('_')[1]
    yield put(setIsButtonDisable(imageDomain === i18next.t(`admin:${ACTIVITY_DEFAULT_IMAGE_MESSAGE}`)))
    const images = yield select(getGalleryActivitiesImages)
    const newFileName = `${imageDomain}__${fileName.split('.')[0]}`
    const isImageNameExist = images.find((image: Map<string, any>) => image.get('fileName') === newFileName)
    yield put(setIsImageNameExist(isImageNameExist !== undefined))
    if (isImageNameExist !== undefined) {
      showWarning({ content: 'admin:This image name is already used.' })
    }
  } catch (error) {
    console.log(error)
    Sentry.withScope(scope => {
      scope.setExtra('where error was happen', 'handleCheckImageName saga')
      Sentry.captureException(error)
    })
    showError()
  }
}
